exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".classic-view #content{padding-top:35px;padding-right:35px;margin-left:0;width:100%;padding-left:35px}.classic-view #content input[type=file]{font-size:inherit!important;outline:none!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/applications/customize/customize.scss
// module id = 1049
// module chunks = 0